module.exports = __webpack_public_path__ + "static/impulse-imports-827ee2e6737cfa77b125b16881539f1e.png";